"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeNewStyleSheet = exports.addColorSchemeToElement = exports.writeColorToken = exports.addOptionalTokens = exports.parseColorTokens = void 0;
var colors_1 = require("../@types/colors");
var stylesheet_1 = require("./stylesheet");
var helpers_1 = require("./helpers");
var processNewColorToken = function (mode, context, color, value) {
    var name = "--".concat(mode, "-").concat(context, "-").concat((0, helpers_1.camelToKebab)(color));
    return {
        name: name,
        value: value,
    };
};
var parseColorTokens = function (scheme) {
    var tokens = [];
    Object.entries(scheme).forEach(function (_a) {
        var modeName = _a[0], modeValue = _a[1];
        tokens.push.apply(tokens, processMode(modeName, modeValue));
    });
    return tokens;
};
exports.parseColorTokens = parseColorTokens;
var processMode = function (modeName, mode) {
    var tokens = [];
    Object.entries(mode).forEach(function (_a) {
        var contextName = _a[0], contextValue = _a[1];
        if (!contextValue)
            return;
        Object.entries(contextValue).forEach(function (_a) {
            var color = _a[0], selectedColor = _a[1];
            var newToken = processNewColorToken(modeName, contextName, color, selectedColor);
            tokens.push(newToken);
        });
        tokens.push.apply(tokens, (0, exports.addOptionalTokens)(modeName, contextName, contextValue));
    });
    return tokens;
};
var addOptionalTokens = function (mode, context, values) {
    var optionalTokens = [
        colors_1.ContextColors.LINK,
        colors_1.ContextColors.PRIMARY_ACTIVE,
        colors_1.ContextColors.PRIMARY_HOVER,
    ];
    var tokens = [];
    optionalTokens.forEach(function (key) {
        if (!values[key]) {
            tokens.push(processNewColorToken(mode, context, key, values.primary));
        }
    });
    return tokens;
};
exports.addOptionalTokens = addOptionalTokens;
var writeColorToken = function (token, element) {
    if (element === void 0) { element = window.document.documentElement; }
    element.style.setProperty(token.name, token.value);
};
exports.writeColorToken = writeColorToken;
var addColorSchemeToElement = function (scheme, element) {
    var parsedTokens = (0, exports.parseColorTokens)(scheme);
    parsedTokens.forEach(function (token) { return (0, exports.writeColorToken)(token, element); });
};
exports.addColorSchemeToElement = addColorSchemeToElement;
var writeNewStyleSheet = function (tokens) {
    var style = (0, stylesheet_1.getStyleSheet)('nebraska-colors');
    var groupedRules = tokens
        .map(function (_a) {
        var name = _a.name, value = _a.value;
        return "".concat(name, ": ").concat(value, ";");
    })
        .join('');
    (0, stylesheet_1.writeRulesOnStyleSheet)(style, ":root { ".concat(groupedRules, " }"));
};
exports.writeNewStyleSheet = writeNewStyleSheet;
